import { render, staticRenderFns } from "./flotte.vue?vue&type=template&id=a4824d96&scoped=true"
import script from "./flotte.vue?vue&type=script&lang=js"
export * from "./flotte.vue?vue&type=script&lang=js"
import style0 from "./flotte.vue?vue&type=style&index=0&id=a4824d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4824d96",
  null
  
)

export default component.exports